<template>
    <headerSearch></headerSearch>
    <div class="w1440 personal_center">
        <div class="flex-box col90 ptb10 page_location">
            当前位置：<router-link class="col04" to="/BaseInfo">用户中心<span class="plr5">/</span></router-link>
            <div class="now_page">发票管理</div>
        </div>
        <div class="flex-box flex-col-start">
            <personal-nav :firstIndex="3" :secondIndex="-1"></personal-nav>
            <div class="ml10 flex-grow-1 part_r">
                <div class="flex-box fs22">
                    <div class="col04 flex-grow-1">我的发票抬头</div>
                    <template v-if="goodsList.length > 0">
                        <div class="flex-box mr45 copy col90 cursor">复制</div>
                        <div class="flex-box mr45 delete col12 cursor">删除</div>
                    </template>
                    <div class="flex-box new colf flex-center cursor fs20" @click="newAddPop = true">新 增</div>
                </div>
                <div v-if="goodsList.length > 0">
                    <div class="list_box mt35">
                        <div class="title_box flex-box col04 fs18">
                            <div class="box1 cursor"></div>
                            <div class="box2 tc">企业名称</div>
                            <div class="box3 tc">税号</div>
                            <div class="flex-grow-1 tc">操作</div>
                        </div>
                        <div class="address_box flex-box col90 fs16" v-for="(item, index) in 10" :key="index">
                            <div class="box1 cursor active"></div>
                            <div class="box2 flex-box flex-center">
                                <div>墨刀科技有限公司</div>
                                <div class="default fs14 colf tc ml5">默认</div>
                            </div>
                            <div class="box3 tc">123456789012345678</div>
                            <router-link class="flex-grow-1 tc cursor" to="TitleEdit">修改</router-link>
                        </div>
                    </div>
                </div>
                <div v-else class="nodata fs16 tc">
                    <img src="../../../assets/static/icon/c_notitle.png" class="c_nodata" alt="">
                    <div>您还没有添加发票抬头哦</div>
                </div>
                <pagination :sumCount="sumCount" :perCount="perCount" v-show="sumCount > perCount"></pagination>

            </div>
        </div>
    </div>
    <popup :visible="newAddPop" @close="newAddPop = false">
        <div class="add_pop relative bgf br10">
            <div class="title_box">
                <img src="../../../assets/static/icon/c_pop_close.png" class="pop_close cursor" @click="newAddPop = false"
                    alt="">
                <div class="title fs24 fwb mb25 col12 flex-box">新增发票抬头</div>
                <div class="fs16 col12">请完善您的发票抬头信息，以便我们更好地为您提供服务。</div>
            </div>
            <div class="form_box">
                <div class="flex-box mb25 fs18 col04">
                    <div class="title must relative">抬头类型</div>
                    <div class="type fwb">企业单位</div>
                </div>
                <div class="title must fs18 col04 relative mb15">企业名称</div>
                <input type="text" class="input fs16 code mb25" placeholder="请输入公司全称">
                <div class="title must fs18 col04 relative mb15">税号</div>
                <input type="text" class="input fs16 code mb25" placeholder="请输入15-20位数和字母">
                <div class="title fs18 col04 relative mb15">地址和电话</div>
                <input type="text" class="input fs16 code mb25" placeholder="请输入地址和电话">
                <div class="title fs18 col04 relative mb15">开户行</div>
                <input type="text" class="input fs16 code mb25" placeholder="请输入开户银行">
                <div class="title fs18 col04 relative mb15">银行卡号</div>
                <input type="text" class="input fs16 code mb25" placeholder="请输入银行卡号">
                <div class="title fs18 col04 relative mb15">备注</div>
                <textarea class="textarea fs16 mb25" placeholder="请填写备注"></textarea>
                <div class="flex-box flex-between cursor" @click="setDefault = !setDefault">
                    <div class="fs18 col04">设为默认抬头</div>
                    <i class="default" :class="setDefault ? 'active' : ''"></i>
                </div>
                <div class="cursor sure fs18 colf">确认</div>
            </div>
        </div>
    </popup>
</template>

<script>
import PersonalNav from "../../../components/PersonalNav.vue";
import { useHead } from '@unhead/vue'
import { onMounted } from "vue"
export default {
    setup() {
        onMounted(() => {
            useHead({
                title: "发票管理-小狮优选",
                meta: [
                    { name: "description", content: "This is my page description" },
                    { property: "og:title", content: "My Page Title" },
                    { property: "og:description", content: "This is my page description" },
                    { property: "og:url", content: "https://example.com/my-page" },
                    { property: "og:image", content: "https://example.com/my-image.jpg" },
                ],
                link: [{ rel: "canonical", href: "https://example.com/my-page" }],
            })
        })
    },
    components: {
        PersonalNav,
    },
    data() {
        return {
            newAddPop: false,
            setDefault: false,
            goodsList: ['', ''],
            sumCount:0,
            perCount:0,
        };
    },
    methods: {

    },
};
</script>

<style lang="less" scoped>
.part_r {
    padding: 32px 44px 100px;
    background: #fff;

    .copy::before {
        display: block;
        content: "";
        width: 22px;
        height: 22px;
        display: block;
        margin-right: 12px;
        background: url('/src/assets/static/icon/c_add_copy.png') no-repeat center;
        background-size: 100%;
    }

    .delete::before {
        display: block;
        content: "";
        width: 20px;
        height: 22px;
        display: block;
        margin-right: 12px;
        background: url('/src/assets/static/icon/c_add_del.png') no-repeat center;
        background-size: 100%;
    }

    .new {
        width: 108px;
        height: 44px;
        border-radius: 6px;
        background: #1275ff;


        &::before {
            display: block;
            content: "";
            width: 18px;
            height: 18px;
            display: block;
            margin-right: 8px;
            background: url('/src/assets/static/icon/c_add_new.png') no-repeat center;
            background-size: 100%;
        }
    }

    .title_box {
        padding-left: 44px;
        height: 50px;
        background: #fafcff;
    }

    .address_box {
        padding-left: 44px;
        height: 136px;
        border-bottom: 1px solid #c0cfdd;
    }

    .box1 {
        width: 20px;
        height: 20px;
        background: url('/src/assets/static/icon/c_check.png') no-repeat center;
        background-size: 100%;

        &.active {
            background-image: url('/src/assets/static/icon/c_check-on.png');
        }
    }

    .box2 {
        width: 405px;
    }

    .box3 {
        width: 350px;
    }

    .default {
        width: 39px;
        height: 18px;
        line-height: 18px;
        border-radius: 4px;
        border: 0.5px solid #aad8fe;
        background: linear-gradient(117deg, #3d6cfe 0%, #4ac3fc 100%);
    }
}

.add_pop {
    .form_box .input.code {
        width: 100%;
    }

    .type {
        padding-left: 66px;
    }

}

.nodata {
    padding-top: 110px;
    height: 380px;
    color: #c9cdd4;

    .c_nodata {
        width: 263px;
        height: 166px;
        display: block;
        margin: 0 auto;
    }
}
</style>
